import {User} from "./player.ts";
import {load, save} from "./storage.ts";

export type Achievement = {
    id: string;
    state: "available" | "hidden" | "earned";
    title: string;
    description: string;
}

async function initEarnedAchievements(): Promise<string[]> {
    await save(achievementsStorageKey, []);
    return [];
}

const achievementsStorageKey = "earned_achievements";

async function getEarnedAchievementsId(user: User): Promise<string[]> {
    return await load<string[]>(achievementsStorageKey)
        ?? await initEarnedAchievements();
}

function getAvailableAchievements(): Achievement[] {
    return [
        {
            id: "completed_first_quest",
            state: "available",
            title: "Первая победа",
            description: "Заверши свой первый квест",
        },
        {
            id: "find_the_third_ruines",
            state: "hidden",
            title: "Далеко забрался",
            description: "Найди третьи руины моста",
        },
    ];
}

export async function getAchievements(user: User): Promise<Achievement[]> {
    const availableAchievements = getAvailableAchievements()
        .filter(({state}) => state !== "hidden");
    const earnedAchievementsId = await getEarnedAchievementsId(user);
    for (const achievement of availableAchievements) {
        if (earnedAchievementsId.includes(achievement.id)) {
            achievement.state = "earned";
        }
    }
    return availableAchievements;
}